module.exports = __webpack_public_path__ + "media/images/frontend/logo_big-4856c5fc685aa2dd005e60c261792abb.png";